import {Alert, IAlertProps, Paragraph, Title} from "@zendeskgarden/react-notifications";
import {ReactElement, ReactNode} from "react";
import * as css from "./styles/vz-alert.module.scss";


export interface VZAlertProps {
    title?: string;
    message: string;
    alertType: IAlertProps["type"];
    action?: ReactNode;
    isCompact?: boolean;
    hideIcon?: boolean;
}

export default function VZAlert({title, message, alertType, action, isCompact}: VZAlertProps): ReactElement {
    return (
        <Alert type={alertType} className={`${css.vzAlert} ${isCompact && css.isCompact}`}>
            { title &&
                <Title>{title}</Title>
            }
            <Paragraph className={css.message}>
                {message}
            </Paragraph>
            {action}
        </Alert>
    );
}